/**
 * Use Global Tabs Hook
 *
 * Exports for the use-global-tabs hook.
 *
 * @since 1.0.0
 */

// Export hook
export { useGlobalTabs } from './hook';

// Re-export types for convenience
export type {
  RedFoxTab,
  RedFoxTabsParams,
  UseGlobalTabsParams,
  UseGlobalTabsReturn,
} from './types';
